angular.module('impactx.invoice').controller('InvoiceAddressCtrl', [
    '$scope',
    'dataGen',
    InvoiceAddressCtrl]);

function InvoiceAddressCtrl($scope, dataGen)
{
    this.onCompanySelect = function(selected)
    {
        if (selected && selected.id > 0)
        {
            if (!selected.setFromBackend)
            {
                dataGen.getData({}, {
                    comId: selected.id,
                    forCreator: $scope.forCreator,
                    forInvoiceReceiver: $scope.forInvoiceReceiver,
                    forGoodsReceiver: $scope.forGoodsReceiver,
                    invoiceReceiverId: $scope.invoiceReceiverId
                }, "/invoice/invoiceaddressforcom").then(function (data)
                {
                    $scope.address = data.data.address;
                    $scope.contact = data.data.contact;
                });
            }
        }
    };

    this.getOrderGoodsReceiverCompanies = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText}, "/invoice/receivercompanies", null, true).then(function(data) {
            return data.data.entries;
        });
    };

}